module.exports = __webpack_public_path__ + "static/img/lixianrenwu2.67eaf59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/lixianrenwu2.png
// module id = ROzh
// module chunks = 24